import {GetProductBulkResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {Breadcrumbs} from '@aboutyou/ui-components';
import React, {FC} from 'react';

export const BreadcrumbsADPView: FC<
  GetProductBulkResponse['linksSection'] & {
    className?: string;
    scrollable?: boolean;
  }
> = ({breadcrumbs, className, scrollable}) => {
  const links = breadcrumbs.map(breadcrumb => ({
    label: breadcrumb.label,
    path: breadcrumb.url?.url ?? '',
  }));

  if (!links.length) {
    return null;
  }

  return (
    <Breadcrumbs className={className} links={links} scrollable={scrollable} />
  );
};
